/** Repères de pilotage proposés, pas un diagnostic fiscal : comparer des flux
 * TTC payés aux recettes clients TTC de la même période, hors apports/prêts.
 * Les quatre bornes sont explicites et injectables pour une future configuration. */
export class ExpenseBurden {
  public constructor(private readonly limits: readonly number[] = [25, 50, 65, 100]) {
    if (
      limits.length !== 4 ||
      limits.some(
        (value, index) =>
          !Number.isInteger(value) ||
          value <= 0 ||
          value > 100 ||
          (index > 0 && value <= limits[index - 1]!),
      ) ||
      limits[3] !== 100
    )
      throw new Error('Repères de dépenses invalides.');
    this.limits = Object.freeze([...limits]);
  }
  public level(expenses: bigint | null, receipts: bigint | null): 0 | 1 | 2 | 3 | 4 | null {
    if (expenses === null || receipts === null) return null;
    if (receipts <= 0n) return expenses > 0n ? 0 : null;
    const ratio = expenses * 100n;
    const tiers = [4, 2, 3, 1] as const;
    for (let i = 0; i < 4; i++) if (ratio <= receipts * BigInt(this.limits[i]!)) return tiers[i]!;
    return 0;
  }
}
